export const separateNumber = (number: string, separate: number = 3) => {
  const re = new RegExp(String.raw`\B(?=(\d{${separate}})+(?!\d))`, 'g')

  return number.replace(re, ',')
}
